var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 794.097656 85.867188 L 722.039062 13.890625 C 714.597656 6.449219 704.816406 2.722656 695.050781 2.722656 C 685.28125 2.722656 675.515625 6.433594 668.078125 13.875 L 610.4375 71.363281 L 736.457031 197.191406 L 794.097656 139.722656 C 808.992188 124.839844 808.992188 100.699219 794.097656 85.867188 Z M 794.097656 85.867188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 236.269531 444.910156 L 362.304688 570.757812 L 709.484375 224.152344 L 583.449219 98.308594 Z M 236.269531 444.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 209.066406 471.835938 L 182.160156 624.496094 L 335.101562 597.667969 Z M 209.066406 471.835938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 557.480469 692.527344 L 82.269531 692.527344 L 82.269531 217.222656 L 417.636719 217.222656 L 500.285156 134.722656 L 53.121094 134.722656 C 23.773438 134.722656 -0.230469 158.730469 -0.230469 188.085938 L -0.230469 721.683594 C -0.230469 751.039062 23.773438 775.046875 53.121094 775.046875 L 586.613281 775.046875 C 615.964844 775.046875 639.964844 751.039062 639.964844 721.683594 L 639.964844 340.183594 L 557.480469 422.535156 Z M 557.480469 692.527344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.ab8ee72a0c0a702405b6e676cf632bd8.svg";
export { ForwardRef as ReactComponent };